<app-pan-card [isPageContainer]="true" [pageContainerSize]="'xl'" [header]="'Uncertain Transactions'">
  <mat-expansion-panel [disabled]="true" [expanded]="filterBoxExpanded" class="mat-elevation-z0" hideToggle="true">
    <mat-expansion-panel-header>
      <div class="flex flex-1 justify-between">
        <div class="flex-1 flex items-center flex-row">
          <span class="mr-3"> Theft Risk </span>

          <app-pan-button-group [(panRadioGroup)]="theftRisk" (panRadioGroupChange)="getMissedFaces()">
            <app-pan-button [panRadio]="'low'" color="info">Low</app-pan-button>
            <app-pan-button [panRadio]="'medium'" color="info">Medium </app-pan-button>
            <app-pan-button [panRadio]="'high'" color="info">High </app-pan-button>
            <app-pan-button [panRadio]="'all'" color="info">All </app-pan-button>
          </app-pan-button-group>
        </div>

        <div>
          <app-pan-button icon="filter_list" (click)="togglePanel()" color="info">
            {{ filterBoxExpanded ? "Hide filters" : "Filter results" }}&nbsp;
          </app-pan-button>
        </div>
      </div>
    </mat-expansion-panel-header>

    <div class="flex mb-7 mt-3">
      <div class="flex">
        <div class="relative">
          <app-pan-floating-label>Cancel Date From</app-pan-floating-label>
          <app-pan-datepicker
            [min]="minDate"
            [max]="maxDate"
            [(date)]="dateFrom"
            (dateChange)="handleDateFromChange()"
            placeholder="Cancel date from"
          >
          </app-pan-datepicker>
        </div>

        <app-pan-button (click)="clearFilterFromDate()" class="ml-5">Clear</app-pan-button>
      </div>

      <div class="ml-5 flex">
        <div class="relative">
          <app-pan-floating-label>Cancel Date To</app-pan-floating-label>
          <app-pan-datepicker
            [min]="minDate"
            [max]="maxDate"
            [(date)]="dateTo"
            (dateChange)="handleDateToChange()"
            placeholder="Cancel date to"
          >
          </app-pan-datepicker>
        </div>

        <app-pan-button (click)="clearFilterToDate()" class="ml-5">Clear</app-pan-button>
      </div>
    </div>

    <div class="max-w-[50%] mb-5">
      <div class="relative">
        <app-pan-floating-label>Filter Locations</app-pan-floating-label>
        <ng-select
          appendTo="body"
          placeholder="Select locations..."
          [bindValue]="'location_id'"
          [bindLabel]="'location_name'"
          [virtualScroll]="true"
          [multiple]="true"
          (change)="changeLocations()"
          [items]="allLocations()"
          [(ngModel)]="selectedLocations"
        >
          <ng-template ng-option-tmp let-item="item"> {{ item.location_name }} ({{ item.branch_name }}) </ng-template>
          <ng-template ng-label-tmp let-item="item"> {{ item.location_name }} ({{ item.branch_name }}) </ng-template>
        </ng-select>
      </div>
    </div>

    <div class="mb-5 flex items-center">
      <app-pan-button (click)="resetFilters()" class="mr-1">Clear all filters</app-pan-button>

      <app-pan-button
        (click)="getMissedFaces()"
        [state]="loadingData ? 'loading' : 'default'"
        [disabled]="loadingData || !highlightApply"
        [color]="highlightApply ? 'primary' : 'default'"
      >
        Apply
      </app-pan-button>
    </div>

    <mat-divider></mat-divider>
  </mat-expansion-panel>

  <div>
    @if (loadingPageData()) {
      <div class="flex justify-center mt-3">
        <app-pan-spinner size="xl"></app-pan-spinner>
      </div>
    } @else if (suspectIdentities?.length === 0) {
      <div class="flex justify-center mt-3">
        <p>No results</p>
      </div>
    }

    <div [class.hidden]="suspectIdentities?.length === 0" class="mat-elevation-z4">
      <div class="example-container mat-elevation-z8">
        <mat-table #table [dataSource]="suspectIdentities" matSort>
          <ng-container matColumnDef="face_id">
            <mat-header-cell *matHeaderCellDef mat-sort-header>Suspect Identity</mat-header-cell>
            <mat-cell *matCellDef="let element" aria-label="" matTooltip="{{ element.face_id }}">
              {{ element.face_id | slice: 0 : 8 }}-...
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="details">
            <mat-header-cell *matHeaderCellDef mat-sort-header>Details</mat-header-cell>
            <mat-cell *matCellDef="let row">
              <app-pan-button
                size="sm"
                color="primary"
                (click)="selectedImageUrl = row.img_id; showTransactionDetailsPopup(row.img_id, row)"
              >
                Show
              </app-pan-button>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="img_id">
            <mat-header-cell *matHeaderCellDef mat-sort-header>Image URL</mat-header-cell>
            <mat-cell *matCellDef="let element">
              <app-pan-button size="sm" color="info" (click)="selectedImageUrl = element.img_id; showImagePopup(element)">
                Show Image
              </app-pan-button>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="location_name">
            <mat-header-cell *matHeaderCellDef mat-sort-header>Location</mat-header-cell>
            <mat-cell
              *matCellDef="let element"
              aria-label=""
              matTooltip="{{ element.location_name?.length > 50 ? element.location_name : '' }}"
            >
              {{ element.location_name | truncate: 50 }}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="branch">
            <mat-header-cell *matHeaderCellDef mat-sort-header>Branch</mat-header-cell>
            <mat-cell *matCellDef="let element" aria-label="" matTooltip="{{ element.branch?.length > 50 ? element.branch : '' }}">
              {{ element.branch | truncate: 50 }}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="theft_category">
            <mat-header-cell *matHeaderCellDef mat-sort-header>Theft Risk</mat-header-cell>
            <mat-cell *matCellDef="let element">
              {{ element.theft_category }}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="total">
            <mat-header-cell *matHeaderCellDef mat-sort-header>Total $</mat-header-cell>
            <mat-cell *matCellDef="let element">{{ element.total | currency }}</mat-cell>
          </ng-container>

          <ng-container matColumnDef="cancel_date">
            <mat-header-cell *matHeaderCellDef mat-sort-header>Cancel date</mat-header-cell>
            <mat-cell *matCellDef="let element">
              {{ element.cancel_date | date: "MM/dd/yyyy h:mm:ss a" }}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="theft">
            <mat-header-cell *matHeaderCellDef mat-sort-header>Theft</mat-header-cell>
            <mat-cell *matCellDef="let element">
              <mat-menu #appMenu="matMenu" xPosition="before">
                @if (element.theftLabel === "No theft" || element.is_theft === null) {
                  <button mat-menu-item (click)="handleTheftChange(true, element)">Theft</button>
                }
                @if (element.theftLabel === "Theft" || element.is_theft === null) {
                  <button mat-menu-item (click)="handleTheftChange(false, element)">No theft</button>
                }
                @if (element.is_theft !== null) {
                  <button mat-menu-item (click)="handleTheftChange(null, element)">Uncertain</button>
                }
              </mat-menu>

              <app-pan-button size="sm" [matMenuTriggerFor]="appMenu" [state]="element.updatingCategory ? 'loading' : 'default'">
                {{ element.theftLabel }}
              </app-pan-button>
            </mat-cell>
          </ng-container>

          <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>

          <mat-row *matRowDef="let row; columns: displayedColumns" class="element-row"> </mat-row>
        </mat-table>
        <mat-paginator [length]="numberOfResults()" [pageSize]="50"></mat-paginator>
      </div>
    </div>
  </div>
</app-pan-card>
